

export const chartType = {
  chart1: {
    title: "dashboard.new_lost_referring_domains.title",
    label: [
      { name: "dashboard.new_lost_referring_domains.new", key: "new", color: "#6366F1" },
      { name:  "dashboard.new_lost_referring_domains.lost", key: "lost", color: "#F43F5E" },
    ],
  },
  chart2: {
    title:  "dashboard.seo_keywords_distribution.title",
    label: [
      { name: "dashboard.seo_keywords_distribution.pos_1_3", key: "p1to3", color: "#F3A344" },
      { name: "dashboard.seo_keywords_distribution.pos_4_10", key: "p4to10", color: "#3BA1C5" },
      { name: "dashboard.seo_keywords_distribution.pos_11_50", key: "p11to50", color: "#365486" },
      { name: "dashboard.seo_keywords_distribution.pos_51_100", key: "p51to100", color: "#E95655" },
    ],
  },
  chart3: {
    title:  "dashboard.backlinks_over_time.title",
    label: [
      { name: "dashboard.backlinks_over_time.backlinks", key: "backlinks", color: "#6366F1" },
      { name: "dashboard.backlinks_over_time.referring_domains", key: "referring_domains", color: "#F43F5E" },
    ],
  },
  chart4: {
    title:"dashboard.total_traffic.title",
    label: [
      { name: "dashboard.total_traffic.organic", key: "organic", color: "#3BA1C5" },
      { name: "dashboard.total_traffic.paid", key: "paid", color: "#E95655" },
    ],
  },
};
